/* Cart drawer */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  var closeBtn = document.getElementById('cart-close');
  var cartToggle = document.getElementById('cart-toggle');
  var cartItems = document.getElementById('cart-items');
  var cartEmpty = document.getElementById('cart-empty');
  var cartFooter = document.getElementById('cart-footer');
  var cartSubtotal = document.getElementById('cart-subtotal');
  var cartCount = document.getElementById('cart-count');
  var shippingBarText = document.getElementById('shipping-bar-text');
  var shippingBarProgress = document.getElementById('shipping-bar-progress');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-active');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-active');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  cartToggle?.addEventListener('click', openDrawer);
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  document.addEventListener('cart:open', openDrawer);
  document.addEventListener('cart:updated', fetchCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-active')) {
      closeDrawer();
    }
  });

  function fetchCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function renderCart(cart) {
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.hidden = cart.item_count === 0;
    }

    if (cart.item_count === 0) {
      if (cartEmpty) cartEmpty.style.display = '';
      if (cartFooter) cartFooter.style.display = 'none';
      // Remove item elements
      cartItems.querySelectorAll('.cart-item').forEach(function (el) { el.remove(); });
      return;
    }

    if (cartEmpty) cartEmpty.style.display = 'none';
    if (cartFooter) cartFooter.style.display = '';

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.featured_image?.url
        ? item.featured_image.url.replace(/(\.[^.]+)$/, '_200x250_crop_center$1')
        : '';

      html += '<div class="cart-item" data-line-key="' + item.key + '">'
        + (imgSrc ? '<img class="cart-item__img" src="' + imgSrc + '" alt="' + item.product_title + '" width="80" height="100" loading="lazy">' : '')
        + '<div class="cart-item__info">'
        + '<h4 class="cart-item__title">' + item.product_title + '</h4>'
        + (item.variant_title ? '<span class="cart-item__variant">' + item.variant_title + '</span>' : '')
        + '<div class="cart-item__bottom">'
        + '<span class="price">' + formatMoney(item.final_line_price) + '</span>'
        + '<button class="cart-item__remove" type="button" data-remove-key="' + item.key + '">Remover</button>'
        + '</div>'
        + '</div>'
        + '</div>';
    });

    // Remove old items, insert new
    cartItems.querySelectorAll('.cart-item').forEach(function (el) { el.remove(); });
    cartItems.insertAdjacentHTML('afterbegin', html);

    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }

    updateShippingBar(cart.total_price);

    // Bind remove buttons
    cartItems.querySelectorAll('[data-remove-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.removeKey;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          });
      });
    });
  }

  function updateShippingBar(totalPrice) {
    if (!shippingBarText || !shippingBarProgress) return;
    var threshold = parseFloat(document.querySelector('[data-free-shipping-threshold]')?.dataset?.freeShippingThreshold || '4999');
    var remaining = threshold - totalPrice;
    var pct = Math.min(100, (totalPrice / threshold) * 100);

    shippingBarProgress.style.width = pct + '%';

    if (remaining <= 0) {
      shippingBarText.innerHTML = 'Parabéns! Tem <strong>envio grátis</strong>!';
      shippingBarProgress.parentElement.parentElement.classList.add('shipping-bar--complete');
    } else {
      shippingBarText.innerHTML = 'Faltam <strong>' + formatMoney(remaining) + '</strong> para envio grátis!';
      shippingBarProgress.parentElement.parentElement.classList.remove('shipping-bar--complete');
    }
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }
})();
